import React from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { GoogleApiWrapper } from 'google-maps-react';

const key = "AIzaSyBkx1bKTdA3gHlubWNJibV-DrfGW0VOpL4";


export default function GoogleApi(component) {
    return GoogleApiWrapper({apiKey: key, libraries: ["places"]})(component);
}